export default {"src":"/_next/static/media/pair-1.cbe4a6a4.svg","height":340,"width":510,"blurWidth":0,"blurHeight":0};